import React from "react";
import "./contact.css";

const ContactUs = () => {
  return (
    <>
      <div>ContactUs</div>
    </>
  );
};

export default ContactUs;
